export enum ActivityType {
    Generic = 0,
    Harvest = 10,
    Packing = 20,
    CropMaintenance = 30,
    Break = 200,
}
